import React, { useEffect, useState,useContext,useRef } from "react";
import Sidebar from "../Components/Sidebar";
import axios from "axios";
import {  Snackbar, Alert, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import TopBar from "../Components/TopBar";
import { useDispatch } from 'react-redux';
import { getMSID, getName, getToken } from '../common';
import { setCalledFrom,resetScreenshotsTop,resetScreenshotsBottom } from '../store/slices/DocumentClaimSlice';
import Popup from "../Components/Popup";
import AppInsight from "../AppInsight";
import { UserContext } from "../Hook/UserContext";
import SnackBar from '../Components/SnackBar';
import useLoader from "../Hook/useLoader";


const IntermediateForm = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {userRole,code1,setCode} = useContext(UserContext);
  const alertRef=useRef(null);
  const name = getName();
  const buttonClicked=useRef(false);
  const[isDisabled,setIsDisabled]=useState(false);
  const [loader, showLoader, hideLoader] = useLoader();

  let role = "";
  if (userRole === 1) {
      role = "manager";
  } else if (userRole === 2) {
      role = "auditor";
  }
  const [msid, setMsid] = useState("");
    useEffect(() => {
      try{
            const loggedUserMsid = getMSID();
            setMsid(loggedUserMsid);
        }
        catch(error){
          AppInsight.trackEvent({ name: `PNA Frontend => msid Error => InterMediateForm, msid=> ${msid}`, properties: { errorMessage: error.message } });
    }
    }, [])
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "claimNumber") {
      if (!/^\d*$/.test(value) && value.length <= 15)
        return;
    }
    if (name === "audited_claim_seq") {
      if (!/^\d*$/.test(value))
        return;
    }
    setInputs({ ...inputs, [name]: value,creator: msid, });
  };

  const formatDate = (date) => {
    const d = new Date(date);
    let month = "" + (d.getMonth() + 1);
    let day = "" + d.getDate();
    const year = d.getFullYear();
    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;
    return [month, day, year].join("-");
  };
  const currentDate = formatDate(new Date());
  const [options, setOption] = useState([]);
  const [inputs, setInputs] = useState({
    claimNumber: "",
    creationDate: currentDate,
    audited_claim_seq:"",
    creator: "",
    rxClaimInstance: "",
  });
  const [showPopUp, setShowPopUp] = useState(false);
  const [formSubmit, setFormSubmit] = useState(false);
  const handleClosePopup=()=>{
    setShowPopUp(false);
    setFormSubmit(true);
  }
  const validate = (values) => {
    const errors = {};
    if (!values.claimNumber) {
      errors.claimNumber = "Claim Number is required!";
    }
    else if (values.claimNumber.length < 15) {
      errors.claimNumber = "Claim Number must be 15 digits";
    }
    if (!values.audited_claim_seq) {
      errors.audited_claim_seq = "Aud. Claim Seq is required!";
    }
    if (!values.rxClaimInstance) {
      errors.rxClaimInstance = "Rx Instance is required!";
    }
    return errors;
  };
  const [snackBarForamttedMsg,setSnackBarForamttedMsg]=useState('');
  useEffect(() => {
    const validations=validate(inputs);
    if (Object.keys(validations).length !== 0) {
const formattedMsg= Object.entries(validations).map(([key,value])=>
    `${value}` ).join('\n');
  setSnackBarForamttedMsg(formattedMsg);
}
}, [inputs]);   

  const handleCancelInputs = (event) => {
    event.preventDefault();
    setInputs({
      claimNumber: "",
      audited_claim_seq:"",
      creationDate: currentDate,
      creator: name,
      rxClaimInstance: "",
    });
  };

useEffect(() => {
    try{
        handleGetApiCall();
    }
    catch(error){     
    AppInsight.trackEvent({ name: `PNA Frontend => api token Error => useEffect => Intermediate Form, msid=> ${msid}`, properties: { errorMessage: error.message } });
}
  }, []);

  const handleGetApiCall = async () => {
    try {
      const token = getToken();
      const header = {
        headers: {
          "Authorization": `Bearer ${token}`,
        },
      };
      AppInsight.trackEvent({ name: `PNA Frontend=>handleGetApiCall API Call started, msid=> ${msid}`});
      const rawResponse = await axios.get(
        process.env.REACT_APP_API_URI + "DropdownBind", header
      );
      AppInsight.trackEvent({ name: `PNA Frontend=>handleGetApiCall API Call completed, msid=> ${msid}`});
      setOption(rawResponse.data.rxInstanceList || []);
    } catch (error) { 
      if(alertRef.current)
          alertRef.current.showSnackbar();
      AppInsight.trackEvent({ name: `PNA Frontend => api token Error => handleGetApiCall, msid=> ${msid}`, properties: { errorMessage: error.message } });
    }
  };

  //post api call
  const handlePostApiCall = async (event) => {
    event.preventDefault();
    console.log("handle intermediate func called")
      if(buttonClicked.current)return;
        buttonClicked.current=true;
        // setIsDisabled(true);
        callIntermediateFormAPI();
      
  };

  const callIntermediateFormAPI = async () => {
    try {
      const token = getToken();
      const header = {
        headers: {
          "Authorization": `Bearer ${token}`,
        },
      };
      dispatch(setCalledFrom("IntermediateForm"));
        dispatch(resetScreenshotsTop());
        dispatch(resetScreenshotsBottom());
        showLoader();
        AppInsight.trackEvent({ name: `PNA Frontend=>callIntermediateFormAPI API Call started, msid=> ${msid}`});
        const response = await axios.post(
          process.env.REACT_APP_API_URI + "IntermediateForm",
          inputs, header
        );
        AppInsight.trackEvent({ name: `PNA Frontend=>callIntermediateFormAPI API Call completed, msid=> ${msid}`});
        if (
          response.data.status ===0) {
          setShowPopUp(false);
          hideLoader();
          if(alertRef.current)
              alertRef.current.showSnackbar("Claim number already in progress/completed","info");
          buttonClicked.current=false;            
        } else if(response.data.status ===1) {
          navigate("/DocumentClaimScreen/"+inputs.claimNumber+inputs.rxClaimInstance+inputs.audited_claim_seq);
          hideLoader();

        }
        else{
          if(alertRef.current)
              alertRef.current.showSnackbar();
          buttonClicked.current=false;
        }
       
      }
    
    catch (error) {
      hideLoader();
      if(alertRef.current)
          alertRef.current.showSnackbar();
      buttonClicked.current=false;  
      AppInsight.trackEvent({ name: `PNA Frontend => api token Error => handlePostApiCall => Intermediate Form, msid=> ${msid}`, properties: { errorMessage: error.message } });
    }
  }

  const handleSubmit=(e)=>{
    e.preventDefault();
    try{
    const validations=validate(inputs);
    if(Object.keys(validations).length> 0){ 
    if(alertRef.current)   
        alertRef.current.showSnackbar(snackBarForamttedMsg,"error");
    }
    else{
      setShowPopUp(true);
    }
  }
  catch(error){
    AppInsight.trackEvent({ name: `PNA Frontend => handleSubmit => Intermediate Form, msid=> ${msid}`, properties: { errorMessage: error.message } });
  }
  }


  return (
    <div>
      <div className="container cssIntermediateForm1">
        <div className="left-panel">
        <Sidebar defaultValue="IntermediateFormScreen" />
        </div>
        {loader}
        <div className="right-panel">
          <div id="main">
            <TopBar role={role}/>
            <br></br>
            <div className="cssIntermediateForm2">
              <div className="cssIntermediateForm3">Claim Creation</div>

              <br></br>
              <br></br>
              <div className="cssIntermediateForm4">
                <form >
                  <label ><sup className="colorRedFontBold" >*</sup>Claim Number</label>
                  <input
                    type="text"
                    name="claimNumber"
                    maxLength="15"
                    value={inputs.claimNumber}
                    onChange={handleChange}
                    required
                    className="form-control cssIntermediateForm5 intermediateFormCssTextField"

                  ></input>
                  <br></br>
                  <br></br>
                  <label ><sup className="colorRedFontBold" >*</sup>Aud. Claim Seq</label>
                  <input
                    type="text"
                    name="audited_claim_seq"
                    value={inputs.audited_claim_seq}
                    onChange={handleChange}
                    maxlength="3"
                    required
                    className="form-control intermediateFormCssTextField1"

                  ></input>
                  <br></br>
                  <br></br>

                  <label><sup className="colorRedFontBold" >*</sup>Rx Instance</label>
                  <select
                  style={{marginLeft:'30px'}}
                    className="form-control cssIntermediateForm6 intermediateFormCssTextField"
                    name="rxClaimInstance"
                    value={inputs.rxClaimInstance}
                    onChange={handleChange}
                  >
                    <option value="" disabled>
                      select instance
                    </option>
                    {options.map((option, index) => (
                      <option key={index} value={option}>
                        {option}
                      </option>
                    ))}
                  </select>
                  <br></br>
                  <br></br>

                  <label>Created Date</label>
                  <input
                    style={{marginLeft:'22px'}}
                    type="text"
                    name="creationDate"
                    value={inputs.creationDate}
                    readOnly
                    className="form-control cssIntermediateForm7 intermediateFormCssTextField2"
                  ></input>
                  <br></br>
                  <br></br>

                  <label>Created By</label>
                  <input
                   style={{marginLeft:'37px'}}
                    type="text"
                    name="creator"
                    value={msid}
                    readOnly
                    className="form-control cssIntermediateForm8 intermediateFormCssTextField2"
                  ></input>
                  <br></br>
                  <br></br>
                  <br></br>

                  <button
                    type="button"
                    onClick={handleSubmit}
                    className="btn btn-primary finalDecisionAndSaveButton cssIntermediateForm9"
                  >
                    Proceed
                  </button>
                                
                                  {showPopUp &&(
                                    <Popup
                                    open={true}
                                    handleClose={handleClosePopup}
                                    handleYes={handlePostApiCall}
                                    handleNo={handleClosePopup}
                                    title='Confirmation'
                                    message='Hope you have verified below mentioned value:'
                                    warningSignWithMessage='You will not be able to update the above values, post this screen!'
                                    buttonYes='Ok'
                                    buttonNo='Cancel'
                                    key1='Claim Number:'
                                    key2='Audited Claim Seq:'
                                    key3='Rx Claim Instance:'
                                    severity='Information'
                                    value1={inputs.claimNumber}
                                    value3={inputs.rxClaimInstance}
                                    value2={inputs.audited_claim_seq}
                                    calledfrom='intermediateFormPopUp'
                                    disabledButton={buttonClicked}
                                    >
                                    </Popup>
              )}
                  <button
                    onClick={handleCancelInputs}
                    className="btn btn-primary finalDecisionAndSaveButton cssIntermediateForm10"
                  >
                    Cancel
                  </button>
                </form>
              </div>
              
            </div>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
          </div>
          <br></br>
        </div>
      </div>
      <SnackBar ref={alertRef}/>     
    </div>
  );
};

export default IntermediateForm;